(() => {
    const initFlyOut = () => {
        let openFlyOutBtns = document.querySelectorAll('.diu-neos-user__flyout__toggle__btn');

        let userflyOut = document.getElementById('userInfoFlyOut');

        if (openFlyOutBtns && userflyOut) {
            openFlyOutBtns.forEach((openFlyOutBtn, index) => {
                openFlyOutBtn.addEventListener('click', function (event) {
                    userflyOut.classList.toggle('diu-neos-user__flyout__container--open');
                });
            });
        }
    };

    document.onreadystatechange = function () {
        if (document.readyState == "complete") {
            initFlyOut();
        }
    }
})();
